import { render, staticRenderFns } from "./REAILogs.vue?vue&type=template&id=35ba317a"
import script from "./REAILogs.vue?vue&type=script&lang=js"
export * from "./REAILogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports